import { buttonCommonProps, DataInputParams } from "./inputType";
import { Debug } from "@/util/debug";
import { Button, FormInstance, Select, Tooltip } from "antd";
import { cn } from "@/lib/utils";
import { useTranslations } from "next-intl";
import { checkDisabled, checkInputDirect } from "./inputFunction";
import { Capacitor } from "@capacitor/core";
// import { getApiHostname } from "@/util/paramutil";

import Icon from "@/components/common/icon/icon";
import { appRouterPush, isAndroidRouter, isNativePlatform, useLinkRouter } from "@/util/apputil";
import { useRouter } from "next/navigation";
import { tooltipColor } from "../list/defaultType";
import { defaultLocale } from "@/i18n/routing";
// import dynamic from "next/dynamic";
// const Icon = dynamic(() => import("@/components/common/icon/icon"), { ssr: false });

export function LinkButton(params: DataInputParams) {
  //const force = params.inputType === "link" ? true : false;
  const diplay = (params.dataInputMode ?? params.inputMode) === "view" && !(params.readInput ?? true);
  const button_front = params.linkPropOption?.linkButtonFront ?? (diplay ? false : true);
  const t = useTranslations(params.transitionGroup ?? "contents");
  const router = useRouter();

  const target_check = params.linkProp?.target ? params.linkProp?.target : params.linkPropOption?.newTab ? "_blank" : undefined;
  const target = target_check ?? ((params.linkPropOption?.linkButtonNewTab ?? true) ? "_blank" : undefined);

  const check_value = params.fixedValue ?? params.value;
  const value_str: string = typeof check_value === "string" ? check_value : check_value ? check_value.toString() : "";
  //hostName 체크
  const appHost = !isNativePlatform
    ? false
    : /^https?:\/\/([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[^\s]*)?$/i.test(value_str)
      ? value_str.indexOf(window.location.origin.toString()) === 0
        ? true
        : false
      : true;
  const link_href =
    appHost && value_str.indexOf(window.location.origin.toString()) === 0
      ? (params.locale === defaultLocale ? "" : "/" + params.locale) + value_str.substring(window.location.origin.toString().length)
      : undefined;

  const tooltip = params.linkPropOption?.linkButtonTitle
    ? (params.linkPropOption.titleTransition ?? true)
      ? t(params.linkPropOption.linkButtonTitle)
      : params.linkPropOption.linkButtonTitle
    : params.linkPropOption?.title
      ? (params.linkPropOption.titleTransition ?? true)
        ? t(params.linkPropOption?.title)
        : params.linkPropOption?.title
      : appHost || !target
        ? t("link")
        : t("newtab");
  return value_str.trim() !== "" && (!diplay || !target_check || (diplay && params.linkPropOption?.linkButtonUse)) ? (
    <Tooltip
      title={(params.linkPropOption?.linkButtonTitleTooltip ?? true) ? tooltip : undefined}
      placement={params.tooltipPlacement}
      {...params.tooltipProps}
    >
      <Button
        className={cn(button_front === "just" ? "" : button_front ? "mr-2" : "ml-2")}
        href={value_str}
        //type={diplay ? "link" : "default"}
        target={appHost ? undefined : target}
        onClick={
          useLinkRouter && isAndroidRouter() && link_href //&& false
            ? (e) => {
                if (link_href) {
                  e.preventDefault();
                  appRouterPush(router, link_href);
                }
              }
            : undefined
        }
        icon={
          (params.linkPropOption?.linkButtonIcon ?? true) ? (
            <Icon iconName={params.linkPropOption?.linkButtonName ?? "Browsers"} iconType="" weight="bold" />
          ) : undefined
        }
      >
        {(params.linkPropOption?.linkButtonTitleTooltip ?? true) ? "" : tooltip}
      </Button>
    </Tooltip>
  ) : (
    <></>
  );
}

export function CopyButton(params: DataInputParams) {
  //const force = params.inputType === "link" ? true : false;
  const copyUse = params.copyProp?.copyButton;
  const value_str: string = typeof params.value === "string" ? params.value : params.value ? params.value.toString() : "";
  const link_input = params.inputType === "link" && !(params.inputMode == "view" && !(params.readInput ?? true));
  const button_front = (params.copyProp?.copyButtonFront ?? link_input) ? true : false;
  const ta = useTranslations("alert");
  const t = useTranslations(params.transitionGroup ?? "contents");
  const tooltip = params.copyProp?.copyTitle
    ? (params.copyProp?.copyTitleTransition ?? true)
      ? t(params.copyProp.copyTitle)
      : params.copyProp.copyTitle
    : t("copy");
  return copyUse && value_str.trim() !== "" ? (
    <Tooltip
      color={tooltipColor}
      title={(params.copyProp?.copyButtonTitleTooltip ?? true) ? tooltip : undefined}
      placement={params.tooltipPlacement}
    >
      <Button
        className={cn(button_front ? "mr-2" : "ml-2")}
        onClick={() => {
          if (params.copyProp?.copyButtonClick) {
            params.copyProp.copyButtonClick(value_str);
          } else {
            try {
              navigator.clipboard.writeText(value_str);
              alert(ta("copy_ok"));
            } catch (e) {
              Debug(e);
            }
          }
        }}
        //type={diplay ? "link" : "default"}
        icon={
          (params.copyProp?.copyButtonIcon ?? true) ? (
            <Icon iconName={params.copyProp?.copyButtonName ?? "CopySimple"} iconType="" weight="bold" />
          ) : undefined
        }
      >
        {(params.copyProp?.copyButtonTitleTooltip ?? true) ? "" : tooltip}
      </Button>
    </Tooltip>
  ) : (
    <></>
  );
}
export function ClearButton(params: DataInputParams) {
  const clearUse = params.clearProp?.clearButton;
  const button_front = params.clearProp?.clearButtonFront ?? false;
  const t = useTranslations(params.transitionGroup ?? "contents");
  const disabled = checkDisabled(params);
  const tooltip = params.clearProp?.clearTitle
    ? (params.clearProp?.clearTitleTransition ?? true)
      ? t(params.clearProp.clearTitle)
      : params.clearProp.clearTitle
    : t("clear");
  return (clearUse ?? false) ? (
    <Tooltip color={tooltipColor} title={tooltip} placement={params.tooltipPlacement}>
      <Button
        className={cn(button_front ? "mr-2" : "ml-2", disabled ? "invisible" : "", params.clearProp?.clearButtonClassName)}
        onClick={() => {
          if (params.form && params.name) {
            const key = params.name;
            params.form.setFieldsValue({ key: undefined });
            if (params.inputDirect) {
              checkInputDirect(params);
            }
          }
        }}
        //type={diplay ? "link" : "default"}
        icon={<Icon iconName={params.clearProp?.clearButtonName ?? "Backspace"} iconType="" weight="bold" />}
      ></Button>
    </Tooltip>
  ) : (
    <></>
  );
}

export function CommonButton(params: buttonCommonProps) {
  const t = useTranslations(params.titleTransitionGroup ?? "contents");
  const title = params.title ? ((params.titleTransition ?? true) ? t(params.title) : params.title) : t("button");
  // Debug(title);
  return (
    <Tooltip color={tooltipColor} title={title}>
      <Button
        className={cn(params.buttonFront === null ? "" : params.buttonFront ? "mr-2" : "ml-2", params.buttonClassName)}
        onClick={params.buttonClick}
        icon={<Icon iconName={params.buttonName ?? "Backspace"} iconType="" weight="bold" />}
        disabled={params.disabled}
      >
        {title}
      </Button>
    </Tooltip>
  );
}

export function UnitSelect(params: DataInputParams) {
  const unitProp = params.unitProp;
  const t = useTranslations(params.transitionGroup ?? "contents");
  if ((params.unitChange ?? true) && unitProp && unitProp.unitList?.length > 0) {
    const disabled = params.inputMode == "view" && (params.readInputDisabled ?? true) ? true : params.disabled;
    const tooltip = unitProp.tooltip ? ((unitProp.tooltipTransition ?? true) ? t(unitProp.tooltip) : unitProp.tooltip) : t("unit_change");
    const valueList = unitProp.unitList.map((item) => {
      if (typeof item === "string") {
        return { value: item, label: item };
      } else {
        return item;
      }
    });
    const value =
      unitProp.convertUnit ??
      unitProp.defaultUnit ??
      (params.unit
        ? typeof params.unit === "string"
          ? params.unit
          : typeof params.unit.element === "string"
            ? params.unit.element
            : undefined
        : undefined);
    const placeholder = unitProp.placeholder
      ? (unitProp.placeholderTransition ?? true)
        ? t(unitProp.placeholder)
        : unitProp.placeholder
      : t("unit_change");
    return (
      <Tooltip color={tooltipColor} title={tooltip} placement={params.tooltipPlacement}>
        <Select
          className={cn(params.unitProp?.unitButtonClassName ?? "ml-2", disabled ? "invisible" : "")}
          defaultValue={value}
          options={valueList}
          onChange={(e: any) => {
            if (params.formFunction && params.name && params.formFunction[params.name] && params.formFunction[params.name]) {
              const setUnit = params.formFunction[params.name]["setUnit"];
              if (setUnit) {
                setUnit(e);
              }
            }
            if (unitProp.onChange) {
              unitProp.onChange(e);
            }
          }}
        />
      </Tooltip>
    );
  } else {
    <></>;
  }
}
